import { Component, Renderer2, ElementRef, Input, TemplateRef, ChangeDetectorRef } from '@angular/core';
import { TooltipPopup } from '../tooltip/tooltip-popup';
import { trigger, state, style, animate, transition } from '@angular/animations';

@Component({
  selector: 're-popover-popup',
  template: "\n    <div class=\"arrow\"></div><h3 class=\"popover-title\" *ngIf=\"title\"><span *ngIf=\"!isTemplateRef(title)\" [innerHTML]=\"title\"></span><ng-template *ngIf=\"isTemplateRef(title)\" [ngTemplateOutlet]=\"title\" [ngTemplateOutletContext]=\"{ $implicit: context }\"></ng-template></h3><div class=\"popover-content\"><span *ngIf=\"!isTemplateRef(content)\" [innerHTML]=\"content\"></span><ng-template *ngIf=\"isTemplateRef(content)\" [ngTemplateOutlet]=\"content\" [ngTemplateOutletContext]=\"{ $implicit: context }\"></ng-template></div>\n  ",
  host: {
    '[class]': '"popover fade  " + placement',
    'style': 'display:none;',
    'role': 'tooltip',
    '[@state]': 'animateState',
    '(@state.done)': 'afterVisibilityAnimation($event)'
  },
  animations: [
    trigger('state', [
      state('void', style({ transform: 'scale(0)' })),
      state('initial', style({ transform: 'scale(0)' })),
      state('visible', style({ transform: 'scale(1)' })),
      state('hidden', style({ transform: 'scale(0)' })),
      transition('* => visible', animate('150ms cubic-bezier(0.0, 0.0, 0.2, 1)')),
      transition('* => hidden', animate('150ms cubic-bezier(0.4, 0.0, 1, 1)')),
    ])
  ]
})
export class PopoverPopupComponent extends TooltipPopup {
  @Input() title: string | TemplateRef<any>;

  constructor(elementRef: ElementRef, renderer: Renderer2, changeDetectorRef: ChangeDetectorRef) {
    super(elementRef, renderer, changeDetectorRef);
  }
}
